import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { requestQuote } from "../../api/user/requestQuote";
import APButton from "./APButton";

const RequestQuoteButton = ({
  opportunityId,
  quoteId,
  backOnRequested = false,
}: {
  opportunityId: string;
  quoteId: string;
  backOnRequested?: boolean;
}) => {
  const navigate = useNavigate();
  const [hasRequestedQuote, setHasRequestedQuote] = useState<boolean>(false);
  const { mutateAsync: mutateRequestQuoteAsync } = requestQuote({
    mutationOptions: {
      successAlertMessage: "Quote Request Sent.",
    },
  });

  const onRequestQuote = () => {
    setHasRequestedQuote(true);
    mutateRequestQuoteAsync({
      regardingOpportunityId: opportunityId,
      quoteId: quoteId,
    });
    if (backOnRequested) {
      navigate(-1);
    }
  };

  return (
    <APButton
      text="Request Quote"
      onClick={onRequestQuote}
      disabled={hasRequestedQuote}
      variant="contained"
      color="secondary"
    />
  );
};

export default RequestQuoteButton;
